export const getDefaultVariant = variants => variants.find(size => size.size === "M");

export const getBulkPrice = ({ variantPrices, totalsNoDiscount, assumptiveQuantity }) => {
  let totals = totalsNoDiscount;

  if (assumptiveQuantity) {
    totals += variantPrices[0] * assumptiveQuantity;
  }

  const currentThreshold = Object.keys(variantPrices).findLast(val => val <= totals);
  return Number(variantPrices[currentThreshold]);
};

export const calculateCompositionTotal = ({
  product,
  prices,
  variantQuantities,
  compositionId,
  totalsNoDiscount
}) => {
  const compQtys = variantQuantities[compositionId] || {};
  const { id, variants } = product.compositions.find(comp => comp.default);
  const defaultVariantId = getDefaultVariant(variants).id;
  const compPrices = prices[compositionId];
  const defaultPrices = prices[id];

  return Object.keys(compQtys).reduce((res, variantId) => {
    const curQty = compQtys[variantId];
    const variantPrices = compPrices?.[variantId] || defaultPrices[defaultVariantId];
    if (curQty)
      return (
        res + curQty * getBulkPrice({ variantPrices, totalsNoDiscount, assumptiveQuantity: 0 })
      );
    return res;
  }, 0);
};

export const calculateProductTotalPrice = ({
  product,
  prices,
  variantQuantities,
  totalsNoDiscount
}) =>
  product.compositions.reduce(
    (res, { id }) =>
      res +
      calculateCompositionTotal({
        product,
        prices,
        variantQuantities,
        compositionId: id,
        totalsNoDiscount
      }),
    0
  );

export const calculateBulkPrice = ({
  variantPrices,
  withAssumptive,
  totalsNoDiscount,
  assumptiveQuantity
}) =>
  getBulkPrice({
    variantPrices,
    totalsNoDiscount,
    assumptiveQuantity: withAssumptive ? assumptiveQuantity : 0
  });

export const compositionPrice = ({
  composition,
  prices,
  productTotalPrice,
  totalsNoDiscount,
  assumptiveQuantity
}) => {
  if (!composition) return 0;
  const { id, variants } = composition;
  // we use defaults to ignore loading
  const defaultVariant = getDefaultVariant(variants);
  const compPrices = prices[id];
  if (compPrices?.[defaultVariant.id]) {
    return calculateBulkPrice({
      variantPrices: compPrices[defaultVariant.id],
      withAssumptive: !productTotalPrice,
      totalsNoDiscount,
      assumptiveQuantity
    });
  }
  return null;
};
